<script lang="ts">
  // A report scaled down to fit its container's width, keeping its shape.
  import ReportCanvas from './ReportCanvas.svelte'
  import { sizeOf } from './context'
  import type { ReportData, ReportOptions } from './types'

  export let data: ReportData
  export let templateId: string
  export let options: Partial<ReportOptions> | null = null

  $: dims = sizeOf(options)
  let className = ''
  export { className as class }

  let width = 0
  $: scale = width / dims.width
</script>

<div class="report-preview {className}" bind:clientWidth={width} style="height: {dims.height * scale}px;">
  {#if width > 0}
    <div class="report-preview-inner" style="width: {dims.width}px; height: {dims.height}px; transform: scale({scale});">
      <ReportCanvas {data} {templateId} {options} />
    </div>
  {/if}
</div>

<style>
  .report-preview {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .report-preview-inner {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: 0 0;
    pointer-events: none;
  }
</style>
